import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DASHBOARD_STAT } from "./apiRoutes";

interface UseGetInvoiceStatusProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getInvoiceStatus = async (communityId: string, year: string) =>
  await axiosAuth.get(
    `${DASHBOARD_STAT(communityId)}/parked-status?year=${year}`
  );

const useGetInvoiceStatus = ({
  communityId,
  year,
  queryParams,
}: UseGetInvoiceStatusProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["invoice-status", communityId],
    queryFn: () => getInvoiceStatus(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!year && (queryParams?.enabled ?? true),
  });
};

export default useGetInvoiceStatus;
